import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { SensorData } from '../../../../model/sensorData';
import { Defrost } from '../../../../model/defrost';
import { Subject, takeUntil } from 'rxjs';
import { ConfirmationDialogComponent } from '../../../shared/confirmation-dialog/confirmation-dialog.component';
import { TranslateService } from '@ngx-translate/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { SnackBarService } from '../../../../services/snackBar.service';
import { SpinnerService } from '../../../../services/spinner.service';
import { ExecutionQTestDefrostService } from '../../../../services/executionQTestDefrost.service';
import { ExecutionEditDefrostEditComponent } from '../../../thermal/execution-edit/execution-edit-defrost-edit.component';

export interface DialogDataDefrostList {
  idEssay: number;
  data: SensorData[];
  idEssayType: number;
}

@Component({
    selector: 'app-execution-q-edit-defrost-list',
    templateUrl: './execution-q-edit-defrost-list.component.html',
    styleUrl: './execution-q-edit-defrost-list.component.scss',
    standalone: false,
})
export class ExecutionQEditDefrostListComponent implements OnInit, OnDestroy {

  displayedColsUsers = ['index', 'startDate', 'endDate', 'type', 'edit', 'delete'];

  defrosts: Defrost[];

  private destroy$ = new Subject<void>();

  constructor(
    private dialogRef: MatDialogRef<ExecutionQEditDefrostListComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogDataDefrostList,
    private defrostService: ExecutionQTestDefrostService,
    private translate: TranslateService,
    public dialog: MatDialog,
    public snackBarService: SnackBarService,
    private spinnerService: SpinnerService) { }

  ngOnInit(): void {
    this.reloadTable();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  reloadTable(): void {
    this.spinnerService.show();
    this.defrostService.findAllFromEssay(this.data.idEssay).pipe(takeUntil(this.destroy$)).subscribe((item: Defrost[]) => {
      this.defrosts = item;
      this.spinnerService.hide();
    })
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  newDefrost(): void {
    this.openDialogEdit(new Defrost());
  }

  editRow(id: number): void {
    this.defrostService.findOne(id).pipe(takeUntil(this.destroy$)).subscribe((item: Defrost) => this.openDialogEdit(item));
  }

  deleteRow(id: number): void {
    const message = this.translate.instant('executionEdit.events.form.save.confirm') as string;

    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      data: { message }
    });

    dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe(result => {
      if (result === true) {
        this.spinnerService.show();

       this.defrostService.delete(id).pipe(takeUntil(this.destroy$)).subscribe(() => {
          this.reloadTable();

          this.spinnerService.hide();
        });
      }
    });

  }

  private openDialogEdit(defrost: Defrost) {
   const dialogRef = this.dialog.open(ExecutionEditDefrostEditComponent, {
      minWidth: '50%',
      maxHeight: '95vh',
      data: {
        defrost,
        data: this.data.data,
        idEssayType: this.data.idEssayType
      }
    });

    dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe((result: Defrost) => {
      if (result != null) {
        result.idEssay = this.data.idEssay;

        this.spinnerService.show();
        this.defrostService.save(result).pipe(takeUntil(this.destroy$)).subscribe(() => {
          this.snackBarService.sendSuccess(this.translate.instant('executionEdit.events.form.save.ok') as string);

          this.spinnerService.hide();

          this.reloadTable();
        }, () => {
          this.snackBarService.sendError(this.translate.instant('executionEdit.events.form.save.error.generic') as string);

          this.spinnerService.hide();

          this.reloadTable();
        });
      }
    });
  }

}
